/** @format */
import LazyLoad from "./../library/LazyLoad";
import Tabs from "./../components/Tabs";

export default class Kitbuilder {
	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Kitbuilder();

		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		// Only exists on main kit builder pages
		if ($(".js-locker-room-btn")) {
			self.checkForLockerRoomUrl(); // Initial check on page load
			self.listenForUrlChanges(); // Set up URL change detection
		}

		// Account kit builder logic
		self.triggerAccountLockerRoom();

		$(document).on("click", ".js-trigger-locker-room", function (e) {
			LazyLoad.loadScripts("[data-lazy-script]");
		});
	}

	checkForLockerRoomUrl() {
		// Update the href and text based on the current URL
		$(".js-locker-room-btn").each(function () {
			const $this = $(this);
			const lockerRoomHref = "#locker-room";
			const kitBuilderHref = $this.data("kit-builder-home");

			if (window.location.href.includes("#/locker-room")) {
				$this.attr("href", kitBuilderHref);
				$this.text("View kit builder");
			} else {
				$this.attr("href", lockerRoomHref);
				$this.text("View locker room");
			}
		});
	}

	listenForUrlChanges() {
		const self = this;

		// Listen for popstate and hashchange events
		window.addEventListener("popstate", () => self.checkForLockerRoomUrl());
		window.addEventListener("hashchange", () => self.checkForLockerRoomUrl());

		// Override pushState and replaceState to detect programmatic URL changes
		const originalPushState = history.pushState;
		const originalReplaceState = history.replaceState;

		history.pushState = function (...args) {
			originalPushState.apply(this, args);
			self.checkForLockerRoomUrl();
		};

		history.replaceState = function (...args) {
			originalReplaceState.apply(this, args);
			self.checkForLockerRoomUrl();
		};
	}

	triggerAccountLockerRoom() {
		if (window.location.href.includes("saved-items#/locker-room")) {
			LazyLoad.loadScripts("[data-lazy-script]");
			Tabs.openTabById("#locker-room");
		}
	}
}
